import { useTranslations } from '@vocab/react';
import { Heading, Stack } from 'braid-design-system';
import { useNavigate } from 'react-router';

import { BackButtonPayAndPost } from 'src/app/shared/components/BackButtonPayAndPost';
import { NAVIGATION_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import { useAnalyticsTracking } from 'src/app/v2/hooks/useAnalyticsTracking/index.ts';

import translations from './.vocab/index.ts';

/**
 * These sections are easier to test and should contain most of the tests for business/stateful logic
 */
export const HeaderSection = () => {
  const { t } = useTranslations(translations);
  const { trackingAdapter } = useAnalyticsTracking();
  const navigate = useNavigate();

  const onBackButtonClicked = () => {
    trackingAdapter.sendLinkEvent({
      eventName: NAVIGATION_PRESSED,
      objectInteraction: 'ecaja-checkout-back-interacted',
    });

    navigate(-1);
  };

  return (
    <Stack space="large">
      <BackButtonPayAndPost onClick={onBackButtonClicked}>
        {t('pay-post-page-link-text')}
      </BackButtonPayAndPost>
      <Heading level="2">{t('pay-post-page-heading')}</Heading>
    </Stack>
  );
};
